import { ListSubheader } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { IUser } from 'src/Definitions';
import ExpandableListItem from '../../common/ExpandableListItem';
import { INavigationSection } from '../../Routes';

const styles = () => {
    return createStyles({
        navLink: {
            color: 'unset',
            textDecoration: 'none',
        },
    });
};

interface INavigationSectionProps extends WithStyles<typeof styles> {
    isOpen: boolean;
    navigationSection: INavigationSection;
    user: IUser;
    headerTextColor?: string;
}

class NavigationSection extends React.Component<INavigationSectionProps> {
    public render() {
        const { isOpen, navigationSection, headerTextColor } = this.props;

        return (
            <div>
                {isOpen && navigationSection.header && (
                    <ListSubheader style={{ color: headerTextColor }}>
                        {navigationSection.header}
                    </ListSubheader>
                )}
                {this.renderNavigationLinks()}
            </div>
        );
    }

    private renderNavigationLinks(): JSX.Element[] {
        const { classes, navigationSection, isOpen, user } = this.props;
        const userRoles = user.roles;

        return navigationSection.navigationRoutes.reduce<JSX.Element[]>((routes, route) => {
            const allowedRoles = route.allowedRoles ? route.allowedRoles : [];
            if (allowedRoles.length === 0 || allowedRoles.some((r) => userRoles.indexOf(r) > -1)) {
                const link = (
                    <Link
                        key={route.path}
                        to={route.navigationLink ? route.navigationLink : route.path}
                        className={classes.navLink}
                    >
                        <ExpandableListItem expanded={isOpen} icon={route.icon} text={route.text} />
                    </Link>
                );
                return routes.concat(link);
            } else {
                return routes;
            }
        }, []);
    }
}

export default withStyles(styles)(NavigationSection);



// WEBPACK FOOTER //
// ./src/core/NavigationSection/NavigationSection.tsx